export enum KeyName {
    Enter = 'Enter',
    Space = 'Space',
    Tab = 'Tab'
}
